import React from 'react'
import { useMemo } from 'sb-hooks'
import cx from 'classnames'

import ProductTag from 'components/product/ProductTag/ProductTag'

import s from './ProductTags.scss'


type ProductTagsProps = {
  className?: string
  items: {
    id: number
    name: string
    img: string
  }[]
}

const ProductTags: React.FunctionComponent<ProductTagsProps> = ({ className, items }) => {
  const filteredItems = useMemo(() => {
    const map = new Map()

    // sometimes one tag can have duplicates
    return items
      .filter(({ id }) => {
        if (!map.has(id)) {
          map.set(id, true)
          return true
        }

        return false
      })
      .filter(({ name }) => name)
  }, [ items ])

  return (
    <div className={cx(s.tags, className)}>
      {
        filteredItems.map(({ name, img }) => (
          <ProductTag
            key={name}
            className={s.tag}
            name={name}
            img={img}
            withTitle={false}
          />
        ))
      }
    </div>
  )
}


export default ProductTags
